module.exports = __webpack_public_path__ + "img/14.6a28dfda.jpg";